<template>
    <div class="main_operate">
        <el-menu default-active="1" class="el-menu-vertical-demo" :collapse="isCollapse">
            <el-submenu index="1">
                <template slot="title">
                    <i class="el-icon-plus"></i>
                </template>
                <el-menu-item-group>
                    <el-menu-item><span class="form-span"><i class="el-icon-picture"></i>图片</span>
                        <eber-upload :index="index" @changePic="changePic"></eber-upload>
                    </el-menu-item>
                </el-menu-item-group>
                <el-menu-item-group>
                    <el-menu-item @click="addParagraph()" :data-index="this.index">
                        <i class="iconfont el-icon-tools728bianjiqi_zitidaxiao" style="padding:0 5px"></i>文字</el-menu-item>
                </el-menu-item-group>
                <el-menu-item-group>
                    <el-menu-item>
                        <span class="form-span"><i class="el-icon-video-camera-solid"></i>视频</span>
                        <eber-upload :index="index" @changePic="changePic"></eber-upload>
                    </el-menu-item>
                </el-menu-item-group>
            </el-submenu>
        </el-menu>
    </div>
</template>
<script>
    import _ from 'lodash'
    export default {
        name: "EberSidebar",
        props: ['index'],
        components: {},
        data() {
            return{
                isCollapse:true
            }
        },
        methods: {
            // 获取当前按钮的index文字添加
            addParagraph() {
                event.preventDefault();
                this.$emit('add', this.index);
            },
            changePic(type,file,index){
                this.$emit('uploadFiles',type,file,0,index);
            }
        }
    }
</script>
<style>
    .main_operate {
        width: 80px;
        float: left;
    }
    .main_operate .el-menu {
        border: none;
    }
    .main_operate .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 100%
    }
    .main_operate .el-submenu [class^=el-icon-] {
        vertical-align: middle;
        margin-right: 5px;
        width: 48px;
        text-align: center;
    }
    .el-icon-arrow-down:before {
        content: none !important;
    }
    .form-control,.upload_input {
        opacity: 0;
        left: 0;
        height: 50px;
        position: absolute;
        top: 0;
        width: 100%;
    }
    .form-span {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
    }
    .el-menu-item-group__title {
        padding: 0 !important;
    }
    .edit-pic img {
        display: block;
        width: 90%;
        background-size: 100%;
    }
</style>
<style scoped>
    .el-menu-item, .el-submenu__title {
        height: 40px;
        line-height: 40px;
    }
    .el-menu-item:hover {
        outline: 0;
        color: #2f92ff;
        background:#fff;
    }
    .el-menu-item:hover i{
        outline: 0;
        color: #2f92ff;
        background:#fff;
    }

</style>